import React from 'react';
import classnames from 'classnames';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons/Icons';

import {
  StyledError,
  StyledSelect,
  StyledInputWrapper,
} from './ui';

const Select = (props) => {
  const {
    StyledSelectComponent = StyledSelect,
    errorMessage = '',
    error = false,
    className,
    half,
    icon = ICONS.CHEVRON_DOWN,
    ...rest,
  } = props;

  const inputClass = classnames(className, {
    'error': error,
  });

  return (
    <StyledInputWrapper
      className={inputClass}
      half={half}
    >
      <StyledSelectComponent
        {...rest}
      />
      {icon && (
        <Icon icon={icon} height="24px" />
      )}
      {error && !!errorMessage && (
        <StyledError dangerouslySetInnerHTML={{__html : errorMessage}} />
      )}
    </StyledInputWrapper>
  );
};

export default Select;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/Select.js